import React from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button, IButtonProps } from 'core-components/library/button'

interface IApplyButtonProps extends IButtonProps {
  text?: string
}

export const ApplyButton = (props: IApplyButtonProps) => {
  return (
    <Button {...props}>
      <Translation text={props.text || 'jbp-apply'} span />
    </Button>
  )
}
